import PlatformDocumentMetadata from "@/features/PlatformDocuments/PlatformDocumentMetadata";
import UploadedPlatformDocumentMetadata from "@/features/PlatformDocuments/UploadedPlatformDocumentMetadata";

export enum NoteVisibilityEnum {
    InternalUsers,
    ExternalUsers,
    SupplierSpecificUsers,
}

// WARNING: This enum is synced with server-side code on the compliance backend and the platform
export enum NoteType {
    Product,
    ProductERPSupplier,
    Supplier,
    ProductSupplier,
    Request,
    ObsolescenceReviewCycle,
    TestRequest,
    PurchaseOrder,
    Lot,
    SupplierEvent,
}

export default class Note {
    id: string | null = null;
    userID: string = "";
    userName: string = "";
    noteText: string = "";
    visibilityLevel: NoteVisibilityEnum = null!;
    noteType: NoteType = null!;
    visibleSupplierID: string = "";
    supplierEventID: string = "";
    modifiedTimestampUTC: Date = new Date();
    uploadedPlatformDocumentMetadatas: UploadedPlatformDocumentMetadata[] = [];
    platformDocumentMetadataIDs: string[] = [];
    platformDocumentMetadatas: PlatformDocumentMetadata[] = [];
}
